import { DeleteOutlined } from '@ant-design/icons';
import { Button, Col, Popconfirm, Row } from 'antd';
import useClearCartMutation from '../../../queries/useClearCartMutation';

interface ClearCartButtonProps {
  onCartCleared: () => void;
  isDisabled: boolean;
}

export default function ClearCartButton({
  onCartCleared,
  isDisabled,
}: ClearCartButtonProps) {
  const { mutate: clearCart, isPending } = useClearCartMutation();

  const isButtonDisabled = isDisabled || isPending;

  const handleClearCart = () => {
    clearCart(undefined, {
      onSuccess: () => {
        onCartCleared();
      },
    });
  };

  return (
    <Popconfirm
      placement='bottomRight'
      title='Are you sure you want to clear the cart?'
      onConfirm={handleClearCart}
      disabled={isButtonDisabled}
      okButtonProps={{
        id: `Cart-Clear_Confirm_Yes`,
      }}
      cancelButtonProps={{
        id: `Cart-Clear_Confirm_No`,
      }}
      okText='Yes'
      cancelText='No'
    >
      <Row justify='end'>
        <Col>
          <Button
            danger
            loading={isPending}
            disabled={isDisabled || isPending}
            icon={<DeleteOutlined style={{ color: 'inherit' }} />}
          >
            Clear cart
          </Button>
        </Col>
      </Row>
    </Popconfirm>
  );
}
